/* istanbul ignore file */
import { createAction } from '@reduxjs/toolkit';
import { Offer } from 'core/offers/entities';

export const selectedOfferUpdated = createAction<Offer>('offers/SELECTED_OFFER_UPDATED');
